import BenchlingConfig from 'BenchlingConfig';
import * as NavConstants from 'constants/NavConstants';
import EditorRoutes from 'foundation/EditorRoutes';
import navigateToURL from 'lib/navigateToURL';
import {defaultProcessManagementSearchParams} from 'processes/dashboard/ProcessSearchParams';
import {RouteBundle} from 'routing/RouteConstants';

export const ProcessesRoutes: RouteBundle = {
  domain: 'processes',
  routes: [
    {urlPattern: 'processes', handler: processesRedirector, legacy: true},
    {urlPattern: 'workflows', handler: processes, legacy: true},
    {urlPattern: 'processes/:processId', handler: processEditorRedirector, legacy: true},
    {
      urlPattern: 'workflows/:processId',
      handler: EditorRoutes.processEditor.bind(EditorRoutes),
      legacy: true,
    },
    {urlPattern: 'process-task-schemas', handler: processTaskSchemasRedirector, legacy: true},
    {
      urlPattern: 'workflow-task-schemas',
      handler: EditorRoutes.processTaskSchemas.bind(EditorRoutes),
      legacy: true,
    },
    {urlPattern: 'process-task-schemas/create', handler: processTaskSchemasCreateRedirector, legacy: true},
    {
      urlPattern: 'workflow-task-schemas/create',
      handler: EditorRoutes.processTaskSchemasCreate.bind(EditorRoutes),
      legacy: true,
    },
    {urlPattern: 'process-task-schemas/:schemaId', handler: processTaskSchemaRedirector, legacy: true},
    {
      urlPattern: 'workflow-task-schemas/:schemaId',
      handler: EditorRoutes.processTaskSchema.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'workflow-tasks/:processTaskId',
      handler: EditorRoutes.processTaskEditor.bind(EditorRoutes),
      legacy: true,
    },
  ],
};

// Exported only for testing.
export function processesRedirector(): void {
  navigateToURL('workflows/', {replace: true});
}

function processes(): void {
  // This URL must be branched on the FE to allow for persistent query strings
  if (BenchlingConfig.WORKFLOWS_ENABLE) {
    EditorRoutes.sidepanelListing(NavConstants.SECTIONS.PROCESSES, defaultProcessManagementSearchParams());
  } else {
    EditorRoutes.workflowDashboard();
  }
}

// Exported only for testing.
export function processEditorRedirector(processId: string): void {
  navigateToURL(`workflows/${processId}`, {replace: true});
}

// Exported only for testing.
export function processTaskSchemasRedirector(): void {
  navigateToURL('workflow-task-schemas/', {replace: true});
}

// Exported only for testing.
export function processTaskSchemasCreateRedirector(): void {
  navigateToURL('workflow-task-schemas/create', {replace: true});
}

// Exported only for testing.
export function processTaskSchemaRedirector(schemaId: string): void {
  navigateToURL(`workflow-task-schemas/${schemaId}`, {replace: true});
}
